import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TaskStatusService from "../../../Domain/TaskStatus/TaskStatus.service";
import FAIcon from "../../UI/FAIcon/FAIcon";
const TaskStatusBadge = (props) => {
    const { icon, color } = TaskStatusService.getIconAndColor(props.taskStatus.id);
    return (_jsxs("span", { className: `badge badge-${color} p-2 ${props.className || ""}`, onClick: props.onClick, children: [_jsx(FAIcon, { icon: icon, className: "mr-2" }), props.taskStatus.label] }));
};
export default TaskStatusBadge;
